import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import MuiDenseTable from "../../../common-utilities/core/mui-dense-table";
import {
  HOSTNAME,
  INTRANETHOSTNAME,
  REPORT_HOSTNAME,
} from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import {
  HTTP_METHODS,
  invokeApi,
  invokeUploadFile,
} from "../../utils/http-service";
import { toast } from "react-toastify";
import { getPLTableHeader } from "./helper";
import { downloadFileFromUrl } from "../../utils/common-utils";

const YtdSummary = ({
  tabIndex,
  filters,
  setFilters,
  dateRanges,
  slug,
  token,
  searchTrigger,
  isDownload,
  setIsDownload,
  setSearchTrigger,
  handleDownloadResponse,
}) => {
  const [columnsList, setColumnsList] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const transformData = (data) => {
    const particularNamesInOrder =
      data.find((item) => item.title === "UEM")?.items.map((i) => i.item) || [];
    // Transform into the desired format

    const formattedData = particularNamesInOrder.map((itemName) => {
      const itemData = { particular: itemName };

      data.forEach((group) => {
        const groupItem = group.items.find((item) => item.item === itemName);
        if (groupItem) {
          itemData[
            `${group.title}~${group.storeCount}~${group.color || "#BBDEFB"}`
          ] = {
            type: group.title,
            ...groupItem,
          };
        }

        itemData["color"] = groupItem?.color;
        itemData["child"] = groupItem?.child;
        itemData["parent"] = groupItem?.parent;
        itemData["bold"] = groupItem?.bold;
        itemData["showNow"] = groupItem?.parent ? false : true;
      });
      return itemData;
    });

    return formattedData;
  };
  const loadData = (reportType) => {
    let params = {};
    let payload = {};
    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }
    // Apply selected filters
    filters.selectedFilters.forEach((filter) => {
      if (filter.id !== "storeCode" && filter.id !== "format" && filter.id !== "storeOpeningDate") {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          params[filter.id] = filter?.value?.map((v) => v.value || v);
        } else if (filter.value) {
          params[filter.id] = filter.value.value || filter.value;
        }
      }
      if (filter.id === "storeCode" || filter.id === "format") {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter?.value?.map((v) => v.value || v);
        } else if (filter.value) {
          payload[filter.id] = filter.value.value || filter.value;
        }
      }
      
      if (filter.id === "storeOpeningDate" && typeof filter.value === "object" && filter.value !== null) {
        if (filter.value.startDate && filter.value.endDate) {
          payload[filter.id] = filter.value;
        }
      }
    });

    if (reportType != "json") {
      params["isDownload"] = true;
    }
    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.YTD_SUMMARY}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        }
        if (reportType === "json") {
          const formattedData = transformData(response || []);

          setDocumentsList(formattedData);

          setColumnsList(getPLTableHeader(formattedData || []));
          setFilters({
            ...filters,
            page: 1,
          });
        } else {
          const handledByModal =
            handleDownloadResponse && handleDownloadResponse(response);
          if (!handledByModal && response.url) {
            downloadFileFromUrl(response.url);
          }
        }
      })
      .catch((err) => {});
    if (searchTrigger) {
      setSearchTrigger(false);
    }
  };
  const onExpandRow = (particular) => {
    const updatedData = documentsList.map((item) => {
      if (item.parent === particular) {
        item.showNow = !item.showNow;
      }
      return item;
    });
    setDocumentsList(updatedData);
  };
  const onPageChange = (page) => {
    setFilters({ ...filters, page });
  };
  useEffect(() => {
    if (tabIndex === 2) {
      loadData("json");
    }
  }, [searchTrigger]);
  useEffect(() => {
    if (isDownload && tabIndex === 2) {
      loadData();
      setIsDownload(false);
    }
  }, [isDownload]);
  return (
    <div>
      {" "}
      <Box>
        <div className="invoice-table">
          <MuiDenseTable
            nestedValue={true}
            columnsList={columnsList}
            dataList={documentsList}
            filters={filters}
            pageCount={1}
            onChange={onPageChange}
            onExpandRow={onExpandRow}
            tableContainerClass="summary-table-con"
            isSmallTable={true}
          />
        </div>
      </Box>
    </div>
  );
};

export default YtdSummary;
